//Reanimator "In View" animation script
var didScroll = true;
window.onscroll = setscroll;
window.onresize = setscroll;
var reanimator_elements = document.querySelectorAll('.animation-element');

function check_if_in_view() {

  const window_height = (window.innerHeight || document.documentElement.clientHeight);

  for(let element of reanimator_elements) {

    const rect = element.getBoundingClientRect();

    // Reveal as soon as any part of the element enters the viewport. This fires at load for
    // anything already on screen (so scrolling can't trigger a late / duplicate fade-in) and is
    // resolution-independent, unlike the old "element must reach the viewport middle" test that
    // left tiles hidden on some screen sizes until you scrolled them into the middle.
    if( rect.top < window_height && rect.bottom > 0 ) {
        element.classList.add('in-view');
    }
  }
}

function setscroll() {
    didScroll = true;
}

setInterval(function() {
    if(didScroll) {
        didScroll = false;
        check_if_in_view();
        user_scrolled();
    }
}, 200);

//Set up scroll events for "scrolled"   
function user_scrolled() {
    var window_top_position = window.pageYOffset | document.body.scrollTop;
  
    if(window_top_position > '50'){
        document.body.classList.add('user-scrolled');
    }
    if(window_top_position < '50'){
        document.body.classList.remove('user-scrolled');;
    }
}

// Reveal whatever is already on screen at page load — no 200ms poll wait, no scroll required.
function reanimator_init() {
    reanimator_elements = document.querySelectorAll('.animation-element');
    check_if_in_view();
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reanimator_init);
} else {
    reanimator_init();
}